export default class {
  constructor(ids = [], assets = {}, type = "css") {
    const self = this

    self.ids = ids
    self.assets = assets
    self.type = type
    self.inject = self.inject.bind(self)

    return new Promise(self.inject)
  }

  inject(resolve, reject) {
    const self = this

    if (!self.ids.length) {
      return resolve()
    }

    const id = self.ids.shift()
    const asset = self.assets[id]

    // console.log('trying', id);

    if (asset.loaded || asset.file) {
      // asset.loaded && console.log('  already loaded');
      // asset.file && console.log('  already loaded inline');
      // loading the next asset in the queue
      return setTimeout(self.inject(resolve, reject))
    }

    const onLoad = (e) => {
      // console.log(e);
      // console.log('probably loaded', e.target.src, self.ids, e.stack);
      asset.loading = false
      asset.loaded = true

      setTimeout(() => {
        if (e.type === "error") {
          return reject()
        }

        self.inject(resolve, reject)
      })
    }

    if (asset.loading) {
      // attaching to already loading asset
      // console.log('already loading');
      asset.el.addEventListener("load", onLoad)
      asset.el.addEventListener("error", onLoad)

      return
    }

    // console.log('loading', asset.url, self.ids);

    let s

    if (self.type === "css") {
      s = document.createElement("link")
      s.rel = "stylesheet"
      s.href = asset.url
    } else {
      s = document.createElement("script")
      s.src = asset.url
      s.async = true
    }

    document.head.appendChild(s)

    // s.addEventListener('load', () => console.log('loaded', asset.url));
    // s.addEventListener('error', () => console.log('errored', asset.url));
    s.addEventListener("load", onLoad)
    s.addEventListener("error", onLoad)

    asset.el = s

    asset.loading = true
    asset.loaded = false
  }
}
